// Const
import { formLimitation } from 'const';

// dayjs
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

// 時間
// 4911d 21h 42m 18s
export function formatDuration(seconds) {
  const date = new Date(seconds * 1000);
  const iso = date.toISOString().substr(11, 8);

  const days = Math.floor(seconds / 86400);
  const [h, m, s] = iso.split(":");

  return `${days}d ${h}h ${m}m ${s}s`;
}

// 格式: 2025/11/21 15:39:40
export function formatTimestamp(ts, space = "/") {
  if (ts === null || ts === undefined || ts === "") {
    return "";
  }

  if (ts.toString().length === 10) {
    ts = ts * 1000;
  }

  const date = new Date(ts);

  if (Number.isNaN(date.getTime())) {
    return "";
  }

  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');

  const hh = String(date.getHours()).padStart(2, '0');
  const MM = String(date.getMinutes()).padStart(2, '0');
  const ss = String(date.getSeconds()).padStart(2, '0');

  return `${yyyy}${space}${mm}${space}${dd} ${hh}:${MM}:${ss}`;
}

export function formatTimestampToMinute(timestamp, separator = "-") {
  if (timestamp === null || timestamp === undefined || timestamp === "") {
    return "";
  }

  const normalizedTimestamp =
    typeof timestamp === "number" && String(timestamp).length === 10
      ? timestamp * 1000
      : timestamp;

  const date = dayjs(normalizedTimestamp);

  if (!date.isValid()) {
    return "";
  }

  return date.format(`YYYY${separator}MM${separator}DD HH:mm`);
}

// 格式: Nov 03, 2025, 4:15:59 PM (如果是今天日期會顯示 Today, 11:51:35 AM)
// Timestamp 單位: milisecond
export function formatTimestampByToday(ms, mode = 'web') {
  const date = new Date(ms);
  const now = new Date();

  const isToday =
    date.getFullYear() === now.getFullYear() &&
    date.getMonth() === now.getMonth() &&
    date.getDate() === now.getDate();

  if (isToday && mode === 'web') {
    return `Today, ${date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    })}`;
  }

  return date.toLocaleString("en-US", {
    month: "short",
    day: "2-digit",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });
}

// 上午格式:
//   2025/10/20 10:00 AM ( 整點模式 )
//   2025/10/20 10:15 AM ( 非整點模式 )
// 下午格式:
//   2025/10/20 2:00 PM ( 整點模式 )
//   2025/10/20 2:15 PM ( 非整點模式 )

// timestamp 單位: unix timestamp
// timeZone 單位: +08:00
// isHourlyMode : Boolean ( 是否為整點模式 )
export function formatTimestampByTimezone(timestamp, timeZone, isHourlyMode = false) {
  const formatString = isHourlyMode ? "YYYY/MM/DD h:00 A" : "YYYY/MM/DD h:mm A";
  const time = dayjs.unix(timestamp).tz(timeZone || "UTC");

  return time.format(formatString);
}

// 格式: 2025/10/20
// timestamp 單位: unix timestamp
export function formatTimestampToYMD(timestamp) {
  const formatString = "YYYY/MM/DD";
  const time = dayjs.unix(timestamp);

  return time.format(formatString);
}
// 單位

export function bytesToKB(bytes) {
  return (bytes / 1024).toFixed(2);
}

export function bytesToMB(bytes) {
  const mb = bytes / (1024 ** 2);
  return isNaN(mb) ? 0 : Number(mb.toFixed(2));
}

export function bytesToGB(bytes) {
  const gb = bytes / (1024 ** 3);
  return isNaN(gb) ? 0 : Number(gb.toFixed(2));
}
